__turbopack_context__.v({
  "className": "truculenta_557c61cb-module__SgAvLW__className",
});
